export default "__VITE_ASSET__CtQ8$Bby__"